import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/shape1.png'
import _imports_1 from '../../assets/img/shape2.svg'
import _imports_2 from '../../assets/img/shape3.svg'
import _imports_3 from '../../assets/img/shape4.svg'
import _imports_4 from '../../assets/img/shape5.png'


const _hoisted_1 = { class: "pricing-area bg-f9f6f6" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-md-6 col-sm-6" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "btn btn-primary",
  type: "button",
  disabled: ""
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "pricing-area bg-f9f6f6" }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-primary" }
const _hoisted_17 = { scope: "row" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "d-flex gap-3" }
const _hoisted_25 = ["name", "value", "onUpdate:modelValue", "id"]
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "list-group" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "list-group" }
const _hoisted_30 = { class: "d-grid gap-2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "d-grid gap-2"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "d-grid gap-2"
}
const _hoisted_35 = ["onClick"]

import { computed, ref } from 'vue'
import { FormationType } from '../../types/formation'
import { Timestamp } from 'firebase/firestore'

import { useToast } from 'vue-toastification'
import { formationStore } from '../../store/formations'
import type { UserType } from '../../types/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'NewCourse',
  setup(__props) {

const store = formationStore()
const toast = useToast()
const isLoading = ref(false)
const newFormation = ref(new FormationType())

const addFormation = async () => {
  isLoading.value = true
  try {
    await store.addFormation(newFormation.value)
    toast.success('Formation enregistrée avec succés')

    newFormation.value = new FormationType()
    isLoading.value = false
  } catch (error: any) {
    toast.warning(error.toString())
    isLoading.value = false
  }
}

const delStudent = async (formation: FormationType, student: UserType) => {
  formation.students = formation.students.filter((item) => item.email !== student.email)
  await updateFormation(formation)
}
const updateFormation = async (formation: FormationType) => {
  isLoading.value = true
  try {
    await store.updateFormation(formation)
    toast.success('Formation mis à jour avec succés')
    newFormation.value = new FormationType()
    isLoading.value = false
  } catch (error: any) {
    toast.warning(error.toString())
    isLoading.value = false
  }
}

const toggleFormation = async (formation: FormationType) => {
  isLoading.value = true
  try {
    formation.enabled = !formation.enabled
    await store.updateFormation(formation)
    toast.success('Formation mis à jour avec succés')
    newFormation.value = new FormationType()
    isLoading.value = false
  } catch (error: any) {
    toast.warning(error.toString())
    isLoading.value = false
  }
}

const allFormations = computed(() => {
  return store.getAllformations()
})

const isDisabled = computed(() => {
  if (newFormation.value.courseName === '') {
    return true
  } else {
    return false
  }
})

const formatDate = (date: Date | Timestamp) => {
  return new Date(date.toString()).toLocaleDateString()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"page-title-area\"><div class=\"d-table\"><div class=\"d-table-cell\"><div class=\"container\"><h2>Nouveau cours</h2><div class=\"bar\"></div></div></div></div><div class=\"shape1\"><img src=\"" + _imports_0 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape3\"><img src=\"" + _imports_2 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape5\"><img src=\"" + _imports_4 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape6 rotateme\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div></div>", 1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "",
                class: "form-label"
              }, "Nom", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newFormation.value.courseName) = $event))
              }, null, 512), [
                [_vModelText, newFormation.value.courseName]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "",
                class: "form-label"
              }, "Prix", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newFormation.value.price) = $event))
              }, null, 512), [
                [_vModelText, newFormation.value.price]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "",
                class: "form-label"
              }, "Mois", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newFormation.value.numberOfMonth) = $event))
              }, null, 512), [
                [_vModelText, newFormation.value.numberOfMonth]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                for: "a",
                class: "form-label"
              }, "Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                cols: "30",
                rows: "10",
                class: "form-control-plaintext",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newFormation.value.description) = $event)),
                id: "a"
              }, null, 512), [
                [_vModelText, newFormation.value.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                for: "",
                class: "form-label"
              }, "Date de début", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                name: "",
                id: "",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newFormation.value.startDate) = $event))
              }, null, 512), [
                [_vModelText, newFormation.value.startDate]
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_9, _cache[11] || (_cache[11] = [
                  _createElementVNode("span", {
                    class: "spinner-border spinner-border-sm",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createTextVNode(" Loading... ")
                ])))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "submit",
                  disabled: isDisabled.value,
                  class: "btn btn-primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (addFormation()))
                }, " Demarré ", 8, _hoisted_10))
          ])
        ])
      ]),
      _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div>", 4))
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-table mt-5" }, [
      _createElementVNode("div", { class: "d-table-cell" }, [
        _createElementVNode("div", { class: "container" }, [
          _createElementVNode("h2", null, "Liste des formations"),
          _createElementVNode("div", { class: "bar" })
        ])
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { scope: "col" }, "Cours"),
                    _createElementVNode("th", { scope: "col" }, "Prix"),
                    _createElementVNode("th", { scope: "col" }, "Duration"),
                    _createElementVNode("th", { scope: "col" }, "Date de début"),
                    _createElementVNode("th", { scope: "col" }, "Max student"),
                    _createElementVNode("th", { scope: "col" }, "Description"),
                    _createElementVNode("th", { scope: "col" }, "Inscription ouvert"),
                    _createElementVNode("th", { scope: "col" }, "Nbre inscris"),
                    _createElementVNode("th", { scope: "col" }, "Nbre interessé"),
                    _createElementVNode("th", { scope: "col" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allFormations.value, (formation, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass(formation.enabled ? 'table-success' : 'table-warning'),
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "",
                          "onUpdate:modelValue": ($event: any) => ((formation.courseName) = $event),
                          id: ""
                        }, null, 8, _hoisted_18), [
                          [_vModelText, formation.courseName]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "",
                          "onUpdate:modelValue": ($event: any) => ((formation.price) = $event),
                          id: ""
                        }, null, 8, _hoisted_19), [
                          [_vModelText, formation.price]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "",
                          "onUpdate:modelValue": ($event: any) => ((formation.numberOfMonth) = $event),
                          id: ""
                        }, null, 8, _hoisted_20), [
                          [_vModelText, formation.numberOfMonth]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(formatDate(formation.startDate )) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          "onUpdate:modelValue": ($event: any) => ((formation.startDate) = $event)
                        }, null, 8, _hoisted_21), [
                          [_vModelText, formation.startDate]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "",
                          "onUpdate:modelValue": ($event: any) => ((formation.maxStudents) = $event),
                          id: ""
                        }, null, 8, _hoisted_22), [
                          [_vModelText, formation.maxStudents]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          cols: "30",
                          rows: "10",
                          class: "form-control-plaintext",
                          "onUpdate:modelValue": ($event: any) => ((formation.description) = $event),
                          id: ""
                        }, null, 8, _hoisted_23), [
                          [_vModelText, formation.description]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (option) => {
                            return _createElementVNode("div", {
                              key: option,
                              class: "form-check"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                name: formation.courseName,
                                value: option,
                                "onUpdate:modelValue": ($event: any) => ((formation.inscription) = $event),
                                id: formation.courseName
                              }, null, 8, _hoisted_25), [
                                [_vModelRadio, formation.inscription]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: formation.courseName
                              }, _toDisplayString(option ? "Demarré" : "Aretté"), 9, _hoisted_26)
                            ])
                          }), 64))
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("ul", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formation.students, (student, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "list-group-item"
                            }, [
                              _createElementVNode("button", {
                                class: "bg-danger text-light small float-end",
                                onClick: ($event: any) => (delStudent(formation, student))
                              }, "Del", 8, _hoisted_28),
                              _createTextVNode(" Nom:" + _toDisplayString(student.name) + " ", 1),
                              _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" Email:" + _toDisplayString(student.email) + " ", 1),
                              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" Numero:" + _toDisplayString(student.mobile), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("ul", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formation.interestedStudents, (student, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "list-group-item"
                            }, [
                              _createTextVNode(" Nom:" + _toDisplayString(student.name) + " ", 1),
                              _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" Email:" + _toDisplayString(student.email) + " ", 1),
                              _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" Numero:" + _toDisplayString(student.mobile), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("button", {
                            type: "button",
                            name: "",
                            id: "",
                            class: "btn btn-primary",
                            onClick: ($event: any) => (updateFormation(formation))
                          }, " Mettre à jour ", 8, _hoisted_31)
                        ]),
                        (formation.enabled)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("button", {
                                type: "button",
                                name: "",
                                id: "",
                                class: "btn btn-danger",
                                onClick: ($event: any) => (toggleFormation(formation))
                              }, " Desactiver ", 8, _hoisted_33)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createElementVNode("button", {
                                type: "button",
                                name: "",
                                id: "",
                                class: "btn btn-success",
                                onClick: ($event: any) => (toggleFormation(formation))
                              }, " Activer ", 8, _hoisted_35)
                            ]))
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"shape8 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape2 rotateme\"><img src=\"" + _imports_1 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape7\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div><div class=\"shape4\"><img src=\"" + _imports_3 + "\" alt=\"IT+ formation cours informatique djibouti\"></div>", 4))
    ])
  ]))
}
}

})